import type { ChangeSetFileContent, ChangeSetInfo } from "@racler/protocol";
import { changeLetter } from "../lib/review.ts";

interface Props {
  files: ChangeSetFileContent[] | null;
  summary: ChangeSetInfo["files"];
  selected: number;
  loading: boolean;
  onSelect: (i: number) => void;
}

/** Compact list of changed files: M / A / D / R old → new, plus the per-file result after an apply attempt. */
export function ReviewFileList({ files, summary, selected, loading, onSelect }: Props) {
  return (
    <ul className="review-files" data-testid="review-files">
      {(files ?? []).map((f, i) => {
        const result = summary.find((x) => x.path === f.path)?.result;
        const label = f.oldPath ? `${f.oldPath} → ${f.path}` : f.path;
        return (
          <li key={f.path}>
            <button
              className={i === selected ? "active" : ""}
              onClick={() => onSelect(i)}
              data-testid={`review-file-${f.path}`}
              title={label}
            >
              <span className={`chg chg-${changeLetter(f.op)}`}>{changeLetter(f.op)}</span>
              <span className="review-path">{label}</span>
              {result && <span className="muted small">{result}</span>}
            </button>
          </li>
        );
      })}
      {loading && <li className="muted small">Loading…</li>}
    </ul>
  );
}
